module.exports = __webpack_public_path__ + "static/1-918269bce06366066050b14264f4a74b.wav";